import { useRouter } from '@tanstack/react-router';
import type { MouseEvent } from 'react';

import { requestGuardedNavigation } from '../model/guardedNavigation';
import { nativeBackFormState } from '../model/nativeBackForms';

/** A tab/account link leaving a settings draft follows the same guard as Back. */
export const useGuardedLink = () => {
  const router = useRouter();
  return (event: MouseEvent<HTMLElement>) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    )
      return;
    const href = event.currentTarget.getAttribute('href');
    if (
      !href?.startsWith('/') ||
      href.startsWith('//') ||
      nativeBackFormState(document.body) === 'ready'
    )
      return;
    event.preventDefault();
    requestGuardedNavigation(() => {
      void router.navigate({ href });
    });
  };
};
